export class Process {
    processId: number;
    processName: string;
    startDate: string;
    endDate: string;
    processSeq:number;
    panel: [];
    constructor(processName: string, startDate: string, endDate: string,processSeq:number) {
        this.processName = processName;
        this.startDate = startDate;
        this.endDate = endDate;
        this.processSeq=processSeq;
    }
}
